module.exports = __webpack_public_path__ + "3fabb57f3251d0b9e2ae15053081bc9e.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/185.png
// module id = 1768
// module chunks = 2